import styles from './styles.module.scss';

import cn from 'classnames';

const Header = ({ auth = false, isResponsive = true, center = false, onClick = () => {}, children, ...props }) => {
  const sidebarExpanded = false; //useSelector(state => state.app.ui.sidebar_expanded);

  return (
    <header
      className={cn(
        sidebarExpanded && isResponsive ? styles.header : styles.headerBig,
        auth && styles.header_auth,
        center && styles.center,
        props.styles,
      )}
      onClick={onClick}
    >
        {children}
    </header>
  );
};

export default Header;
